'use strict';

wbApp.directive('wbAttendanceTypeLookup', ['$timeout',
    function ($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            replace: true,
            priority: 1,
            template: "<select class='form-control'>" +
                         "<option value='0' disabled>{{'TXT_VAL_REGISTERED' | translate}}</option>" +
                         "<option value='1'>{{'TXT_VAL_ONEOFF' | translate}}</option>" +
                         "<option value='2'>{{'TXT_VAL_AMEND' | translate}}</option>" +
                         "<option value='3'>{{'TAX_VAL_PREVIEW' | translate}}</option>" +
                      "</select>",
            link: function (scope, elm, attrs, controller) {
                $timeout(function () {
                    $(elm).select2({
                        minimumResultsForSearch: -1
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });
                }, 1);
            }
        }
    }]);
